// Form-related constants
export const QUOTE_DIALOG = {
  TITLE: "Richiedi Preventivo Gratuito",
  SUBTITLE: "Compila il form per ricevere un preventivo dettagliato e personalizzato entro 24 ore",
  LOADING_TEXT: "Invio in corso...",
  SUCCESS_MESSAGE: "Richiesta inviata con successo!",
  ERROR_MESSAGE: "Si è verificato un errore. Riprova.",
} as const;

export const QUOTE_FORM_CONFIG = {
  DEFAULT_TITLE: "Richiedi Preventivo Gratuito",
  DEFAULT_SUBTITLE: "Compila il form per ricevere un preventivo personalizzato",
  DEFAULT_BUTTON_TEXT: "Richiedi Preventivo",
  SUBMIT_BUTTON_TEXT: "Invia Richiesta",
  PRIVACY_TEXT: "Accetto il trattamento dei dati personali secondo la Privacy Policy *",
  REQUIRED_INDICATOR: " *",
} as const;

export const FORM_FIELDS = {
  PLACEHOLDERS: {
    FIRST_NAME: "Nome *",
    LAST_NAME: "Cognome *",
    NAME: "Il tuo nome",
    EMAIL: "Email *",
    EMAIL_EXAMPLE: "la.tua.email@esempio.com", 
    PHONE: "Telefono *",
    PHONE_EXAMPLE: "Il tuo numero di telefono",
    ADDRESS: "Indirizzo",
    ADDRESS_EXAMPLE: "Via/Piazza e numero civico",
    CITY: "Comune",
    CITY_EXAMPLE: "Roma",
    SERVICE_TYPE: "Servizio richiesto",
    PROPERTY_TYPE: "Tipo di immobile",
    MESSAGE: "Descrivi il tuo problema o richiesta...",
    PROBLEM_DESCRIPTION: "Descrivi il problema (tipo di infestante, zone interessate, quando si è manifestato...)",
  },
  LABELS: {
    NAME: "Nome e Cognome",
    EMAIL: "Email",
    PHONE: "Telefono", 
    ADDRESS: "Indirizzo",
    CITY: "Città",
    SERVICE_TYPE: "Tipo di servizio",
    MESSAGE: "Messaggio",
  },
  VALIDATION_MESSAGES: {
    REQUIRED: "Questo campo è obbligatorio",
    INVALID_EMAIL: "Inserisci un'email valida",
    INVALID_PHONE: "Inserisci un numero di telefono valido",
  },
} as const;

// Importazione dai tipi centralizzati per evitare duplicazioni
export { SERVICE_TYPE_OPTIONS as SERVICE_OPTIONS, PROPERTY_TYPE_OPTIONS } from '../types/forms';